jQuery(function ($) {
    $(document).on('click', '.js-print-link', function (e) {
        e.preventDefault();
        window.print();
    });
});
